// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-Inventory-Summary-List-__List___2mElN","c20":"app-pages-Inventory-Summary-List-__List___121j7","c12":"app-pages-Inventory-Summary-List-__List___2_bHM","table-header":"app-pages-Inventory-Summary-List-__List___3VROi","table-content-wrapper":"app-pages-Inventory-Summary-List-__List___3ndj7","table-content":"app-pages-Inventory-Summary-List-__List___2xt-h"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Inventory/Summary/List/List.css
// module id = 2138
// module chunks = 0